import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import moment from 'moment';
import { DogEvent, DogEventDetails } from './types';

const isLocal = window.location.toString().includes('localhost');

type GetEventsParamType = {
  month?: string;
  year?: string;
  zip?: string;
  radius?: string;
  events?: string;
  status?: string;
  entryMethod?: string;
};

export const useGetEvents = (
  params: GetEventsParamType = {
    month: moment().format('MM'),
    year: moment().format('YYYY'),
    zip: '22066',
    radius: '100',
  }
) => {
  return useQuery({
    queryKey: ['events', params],
    queryFn: async () => {
      const { data } = await axios({
        method: 'GET',
        url: `${isLocal ? 'http://localhost:5000' : ''}/api/`,
        params,
      });
      return data as DogEvent[];
    },
    retry: false,
  });
};

export const useGetEvent = (event_type: string, event_id: string) => {
  return useQuery({
    queryKey: ['events'],
    queryFn: async () => {
      const { data } = await axios({
        method: 'GET',
        url: `${isLocal ? 'http://localhost:5000' : ''}/api/${event_type}/${event_id}`,
      });
      return data as DogEventDetails;
    },
    retry: false,
  });
};
